import 'magnific-popup';

function searchPopup() {
	$('.search-icon').on('click', function(e) {
		$('.ui-autocomplete').html('')
		$('input[name="q"]').val('')
	})

	$('.search-icon').magnificPopup({
		type:'inline',
		mainClass: 'magnific-search',
		removalDelay: 300,
		closeBtnInside: false,
		focus: '.field'
	});
}

export default searchPopup();



// WEBPACK FOOTER //
// ../markup/assets/js/search-popup.js